var option_webview_default = {
  "option": "-piaJ",
  "user_choice": "MhMuB",
  "check": "_6Hnph",
  "image": "bUddW",
  "input": "qMIdn",
  "title": "pRiGL",
  "centered": "kfbu5",
  "with_result": "P2dZc",
  "list": "LPNZ0",
  "with_image": "_8h2Vc",
  "progress": "KoG8g",
  "progress_value": "aESGu",
  "label": "UkAbp",
  "cta": "_1Hddc",
  "adornment_icon": "f4-ol",
  "remove": "UGSda",
  "removeButton": "f9YL-",
  "removeButtonIcon": "YgeZt",
  "overlay": "js4-p",
  "shown": "_7oIWm",
  "dark": "hWf9h",
  "spinner": "syflf",
  "spin": "ybfR7",
  "grid": "rjKet"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
